import { createApp } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3';
import * as VeeValidate from 'vee-validate';
import '../node_modules/@vueform/slider/themes/default.css';
import './style.css';
import App from './App.vue'
import FormValidationMsg from './components/FormValidationMsg.vue';
import FieldSelect from "./components/FieldSelect.vue";
import FieldNumber from "./components/FieldNumber.vue";
import FieldNote from "./components/FieldNote.vue";
import FieldSlider from "./components/FieldSlider.vue";
import FieldSliderStepper from "./components/FieldSliderStepper.vue";
import FieldLabel from "./components/FieldLabel.vue";
import FieldRadio from "./components/FieldRadio.vue";
import FieldCheckbox from "./components/FieldCheckbox.vue";
import Result from "./components/Result.vue";
import Calculator from './components/Calculator.vue';
import CalculateButton from './components/CalculateButton.vue';
import FieldSliderInput from './components/FieldSliderInput.vue';

const loadCalculators = () => {
  document.querySelectorAll('.calculator').forEach(calc => {
    const _lang = calc.getAttribute('lang')
    const _productItem = calc.getAttribute('productItem')
    const _restUrl = window.RestBaseUrl + calc.getAttribute('restUrl')

    const app = createApp(App, { lang: _lang, productItem: _productItem, restUrl: _restUrl });

    app.use(VeeValidate);
    app.use(VueReCaptcha, { siteKey: window.site_recaptcha_key });

    app.component('FormValidationMsg', FormValidationMsg);
    app.component('FieldCheckbox', FieldCheckbox);
    app.component('FieldRadio', FieldRadio);
    app.component('FieldSelect', FieldSelect);
    app.component('FieldNumber', FieldNumber);
    app.component('FieldNote', FieldNote);
    app.component('FieldSlider', FieldSlider);
    app.component('FieldSliderStepper', FieldSliderStepper);
    app.component('FieldSliderInput', FieldSliderInput);
    app.component('FieldLabel', FieldLabel);
    app.component('Result', Result);
    app.component('CalculateButton', CalculateButton);
    app.component('Calculator', Calculator);
    app.mount(calc);

  })
}

window.addEventListener('DOMContentLoaded', async () => {
  // await getToken();
  loadCalculators();
});
